<template lang="pug">
    Button(
        @click="purgeBucket" 
        :loading="isLoading" 
        :shape="shape"
        style="padding: 8px"
    )
        img(
            src="/static/img/broom.svg"
            style="width: 16px;"
        )
</template>

<script>
import { purgeBucket } from "@/api/edges";

export default {
    name: "ClearWafBtn",
    components: {},
    data() {
        return {
            isLoading: false,
            confirmData: {
                placeholder: this.$t("wafrules.clearBucketPlaceholder"),
                actionSuccessText: this.$t("global.success"),
                actionFalseText: this.$t("global.error")
            }
        };
    },
    props: {
        shape: { default: "circle" },
        bucketData: {
            groupName: "",
            section: "",
            servername: "",
            wafrule: "",
            ip: ""
        }
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        async purgeBucket() {
            var self = this;
            let width = 420;
            if ("en-US" == this.$store.state.userPref.lang) {
                width = 550;
            }
            if (this.bucketData.ip == "") {
                this.$Modal.confirm({
                    cancelText: "關閉",
                    width,
                    render: h => {
                        return h("Input", {
                            props: {
                                value: this.inputVal,
                                autofocus: true,
                                placeholder: self.confirmData.placeholder
                            },
                            on: {
                                input: val => {
                                    self.bucketData.ip = val;
                                }
                            }
                        });
                    },
                    onOk: async function() {
                        self.isLoading = true;
                        let result = await purgeBucket(self.bucketData);
                        if (result.data.success) {
                            self.$Message.success(self.$t("global.success"));
                        } else {
                            self.$Message.error(self.$t("global.error"));
                        }
                        self.bucketData.ip = "";
                        self.isLoading = false;
                    }
                });
            } else {
                self.isLoading = true;
                let result = await purgeBucket(self.bucketData);
                if (result.data.success) {
                    self.$Message.success(self.$t("global.success"));
                } else {
                    self.$Message.error(self.$t("global.error"));
                }
                self.isLoading = false;
            }
        }
    },
    computed: {},
    beforeDestroy() {}
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/ClearWafBtn.vue